export const ABOUT_YOU_LSS_ROUTER_TO = {
  pathname: '/falar-com-especialista',
  hash: '#lss'
}
